import React from 'react';
import { Routes, Route } from 'react-router-dom'; 
import Header from './components/common/Header/Header';

// --- 1. IMPORT YOUR PAGES (with the correct folder paths) ---
// This path now correctly points inside the 'pages' folder
import LandingPage from './pages/LandingPage/LandingPage'; 
import ContactUs from './pages/ContactUs/ContactUs'; 
import LoginPage from './pages/Login/Login';
import SignUp from './pages/SignUp/SignUp';
import Lessons from './pages/Lessons/Lessons';

function App() {
  return (
    <div className="App">
      {/* Header and Footer are OUTSIDE <Routes> 
          so they stay on every page */}
      <Header isHeaderVisible={true} /> 
      
      <main>
        {/* --- 2. <Routes> tells React where to render the pages --- */}
        <Routes>
          
          {/* When the path is exactly "/", show the LandingPage */}
          <Route path="/" element={<LandingPage />} />
          
          {/* This path MUST match your <Link> 'to' prop */}
          <Route path="/ContuctUs" element={<ContactUs />} />

          <Route path="/Login" element={<LoginPage />} />

          <Route path="/SignUp" element={<SignUp />} />

          <Route path="/Lessons" element={<Lessons />} />

          {/* <Route path="/signup" element={<SignupPage />} /> */}
        </Routes>
      </main>
    </div>
  );
}

export default App;